<script setup lang="ts">
import VDialog from '~/components/common/VDialog.vue';
import VDrawer from '~/components/common/VDrawer.vue';

type Props = {
  title?: string;
  open: boolean;
  closable?: boolean;
};

const props = defineProps<Props>();
const emit = defineEmits(['open', 'close']);

const onClose = () => emit('close');

const isClient = ref(import.meta.client);

const isClientDesktop = computed(() => {
  const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return !regex.test(navigator.userAgent);
});

watch(
  () => props.open,
  (isOpen) => {
    if (isOpen) useJivoStore().isHidden = true;
    else useJivoStore().isHidden = false;
  }
);
</script>

<template>
  <v-drawer
    v-if="!isClient ? !$device?.isDesktop : !isClientDesktop"
    :open="props.open"
    :title="title"
    class="modal-drawer"
    @close="onClose"
  >
    <slot name="default" />
  </v-drawer>
  <v-dialog
    v-if="(!isClient ? $device?.isDesktop : isClientDesktop) && props.open"
    :closable="closable"
    :title="title"
    @close="onClose"
  >
    <slot name="default" />
  </v-dialog>
</template>

<style lang="scss">
.modal-drawer {
}
</style>
